import { useCallback } from 'react';
import { TransferBody, requestTransfer } from '../../../services/financeTransferService';
import { MoneyRequest } from '../../../services/moneyRequestApi';

interface UseRequestTransferOptions {
  onSuccess?: (data: MoneyRequest) => void;
  onError?: (error: Error) => void;
}

/**
 * Creates a transfer REQUEST. Nothing is signed or sent here: another admin approves it under
 * Finance > Transfer requests, and the server signs and broadcasts it once (XBIT-4530).
 */
const useSignTransaction = () => {
  const requestTransferCb = useCallback(
    async (body: TransferBody, options?: UseRequestTransferOptions) => {
      try {
        const data = await requestTransfer(body);
        options?.onSuccess?.(data);
        return data;
      } catch (error: any) {
        options?.onError?.(error);
        return undefined;
      }
    },
    []
  );

  return {
    requestTransfer: requestTransferCb,
  };
};

export default useSignTransaction;
